<template>
  <div>
    <select-base
      v-model="valueInner"
      :disabled="disabled"
      :multiple="multiple"
      :clearable="clearable"
      :label="'Modelo'"
      :label-select="'nome'"
      :carregar="carregarModelos"
      @input="enviarParaPai"
    />
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import api from '@/app-modulo/documento/modelo/shared/services/api'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'ModeloSelect',
  components: {
    SelectBase: () => import('@/shared/components/select-base/SelectBase.vue'),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    invalido: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => { },
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    naoRecorrente: {
      type: Boolean,
      default: false,
    },
    apenasAtivos: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value_: null,
      filtros: [
        {
          coluna: 'Nome',
          valor: '',
        },
      ],
    }
  },
  computed: {
    valueInner: {
      set(value) {
        this.value_ = value
      },
      get() {
        return this.value_
      },
    },
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
      }
    },
  },
  created() {
    this.valueInner = this.value
  },
  methods: {
    carregarModelos(filtros) {
      filtros.push({
        colunas: ['TipoModelo'],
        valor: this.naoRecorrente ? '1' : '',
      })
      if (this.apenasAtivos) {
        filtros.push(
          {
            colunas: ['Ativo'],
            valor: true,
          },
        )
      }
      return api.getModelosResumidos(filtros)
    },
    enviarParaPai() {
      this.$emit('input', this.valueInner)
    },
  },
}
</script>
